import { useState } from "react";
import { Section } from "@/components/common";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DOC_TYPES } from "@/lib/i18n";
import { PhotoGallery } from "./PhotoGallery";

export function VehicleDocsTab({ vehicleId, canUpload }) {
  const [docType, setDocType] = useState("carte_grise");
  return (
    <Section title="Documents & photos du véhicule" testId="vehicle-docs" action={canUpload && (
      <Select value={docType} onValueChange={setDocType}>
        <SelectTrigger className="h-9 w-[230px] text-xs" data-testid="vehicle-doc-type"><SelectValue /></SelectTrigger>
        <SelectContent>{Object.entries(DOC_TYPES).map(([k, v]) => <SelectItem key={k} value={k} data-testid={`vehicle-doc-type-${k}`}>{v}</SelectItem>)}</SelectContent>
      </Select>
    )}>
      <p className="mb-3 text-xs text-muted-foreground">Certificat d'immatriculation, contrôle technique, assurance… Choisissez le type, puis prenez une photo ou importez un PDF. Stockage sécurisé, accès réservé à l'équipe.</p>
      <PhotoGallery meta={{ entity_type: "vehicle", entity_id: vehicleId }} uploaderExtra={{ doc_type: docType, phase: docType === "photo" ? "photo" : "document" }} canUpload={canUpload} allowPdf size="lg" testId="vehicle-docs-gallery" emptyText="Aucun document" />
    </Section>
  );
}
